import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-pal',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: true
})
export class FooterComponent {

}
